export default {
    data() {
      return {
        sideNavOpen: false,
      };
    },
    methods: {
      addOpen: function (e) {
        e.target.classList.add("open");
      },
      removeOpen: function (e) {
        e.target.classList.remove("open");
      },
      toggleSideNav: function () {
        this.sideNavOpen = !this.sideNavOpen;
      },
      closeSideNav: function () {
        this.sideNavOpen = false;
      },
  },
};